export default __webpack_public_path__ + "static/media/2.b812ffa0.jpg";